import styled from "@emotion/styled";

const Input = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 14px;
  font-size: 15px;
  border: 1px solid #d9dde2;
  border-radius: 10px;
  background: #ffffff;
  color: #222222;
  outline: none;

  &:focus {
    border-color: #003580;
  }
  &::placeholder {
    color: #b8bcc2;
  }
  &:disabled {
    background: #f6f7f9;
    color: #888888;
  }
`;

export default Input;
